import { render, staticRenderFns } from "./ScriptDetails.vue?vue&type=template&id=0356eb0b"
import script from "./ScriptDetails.vue?vue&type=script&lang=js"
export * from "./ScriptDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports